export const settingsRoutesStates = {
  general: 'dashboard.settings.general',
  manageUsers: 'dashboard.settings.manage-users',
  manageAccounts: 'dashboard.settings.manage-accounts',
};
